module.exports = __webpack_public_path__ + "static/media/1.2c6345ab.png";